import { useEffect, useState } from "react";
import Config from "../../Config";
import AppContext from "../../AppContext";
import InputComboRok from "../../helpers/InputComboRok";
import InputComboMiesiac from "../../helpers/InputComboMiesiac";



import { PieChart, Pie, Cell, BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, } from "recharts"
import FormatDecimal from "../../helpers/FormatDecimal";


function Sum(props)
{
 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);
    
    const [salda, setSalda] = useState([]);


    const [view, setView] = useState ( "list");

    const [filterParam, setFilterParam] = useState({   
            
        rok:  props.mainView.readFilter('rok','_x_'),    
        miesiac:  props.mainView.readFilter('miesiac','_x_'),    
          
    });


     const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
    }

    
    
     const getTab = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_rap,sum', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


       
     const getSalda = () => {
        
      
       props.mainView.showProgress();

        fetch( Config.url + '/rest_v1_rap,salda', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server.." , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setSalda(res.result);                                         
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



     const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });               
    }

   
   const onSuccess = ( ) => {                
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        getTab();
    }





    const keyListener = (e) => {
        props.keyListener(e);
    }


    useEffect( ()=>{

            if(Config.env == "dev") console.log("Sum.js, listener on");
            window.onkeydown = keyListener;   
                    
            
            return () => {   
                 if(Config.env == "dev") console.log("Sum.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );




    
    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });        
        setTab(null);     
        getSalda();  
    }



    if(tab == null)
    {
        setTab([]);
        getTab();  
        getSalda();       
        return <div>
            ...
        </div>
    }




    
    const colors = ['#6aa44b', '#f25c37' ];
    const colors2 = ['#69b6bd', '#5482ac' ];

   
    var fData = new Array();
    var tData = new Array();

    
        fData = [
            {  nazwa: "Rozliczone",  wartosc: tab.zaplacone },
            {  nazwa: "Nierozliczone", wartosc: tab.niezaplacone },
        ];

       tData = [
            {  nazwa: "Wystawione",  wartosc: tab.wystawione },
            {  nazwa: "Po terminie", wartosc: tab.po_terminie },
       ];
 


      var barData  = [];
      //var barData2  = [];

      barData = salda;



    return  <div className="view_content">
                 
               <h3 className="dash_header">Podsumowanie rozliczeń</h3>
               
               <div className="table_filter">

                     <div className="filter_controll">   
                                            <label>Rok: </label>                             
                                            <InputComboRok value={filterParam.rok}   valChange={valChangeListener} goNext={null} name="rok" placeholder={": "}   />
                    </div>  

                    <div className="filter_controll">   
                                            <label>Miesiąc: </label>                             
                                            <InputComboMiesiac value={filterParam.miesiac}   valChange={valChangeListener} goNext={null} name="miesiac" placeholder={": "}   />
                    </div>  

               </div>


        <div className="">

                    <div className="rap_half">

                        <div className="rap_title">Wystawione faktury (Zapłacone: {tab.zaplacone}, Niezapłacone: {tab.niezaplacone})</div>   
                        <ResponsiveContainer width="100%" height={300}>
                                <PieChart width={200} height={300}>
                                            <Pie
                                            data={fData}
                                            dataKey="wartosc"
                                            nameKey="nazwa"
                                            cx="50%"
                                            cy="50%"
                                            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                            labelLine={false}
                                            >
                                            {
                                                fData.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                                                ))
                                            }
                                            </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                </div>

                <div className="rap_half">

                        <div className="rap_title">Terminowość spłat (Wystawionych: {tab.wystawione}, Niezapłacone po term.: {tab.po_terminie})</div>   
                        <ResponsiveContainer width="100%" height={300}>
                                <PieChart width={200} height={300}>
                                            <Pie
                                            data={tData}
                                            dataKey="wartosc"
                                            nameKey="nazwa"
                                            cx="50%"
                                            cy="50%"
                                            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                            labelLine={false}
                                            >
                                            {
                                                fData.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={colors2[index % colors2.length]} />
                                                ))
                                            }
                                            </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                </div>
                

        </div>

        <div>



       <h3 className="dash_header">Aktualne zestawienie sald</h3>


            <div className="rap_inline">
                <div className="rap_title">Salda klientów (aktywne umowy, bez sald 0,00)</div>   
                <ResponsiveContainer width="100%" height={400}>
                                <BarChart
                                    data={barData}
                                    margin={{
                                    top: 5,
                                    right: 30,
                                    left: 20,
                                    bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="Nazwa" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="Saldo" fill="#5482ac" />
                            
                                </BarChart>
                </ResponsiveContainer>
            </div>

     </div>



          <div className="bg_center">

                          <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                
                                                <td>Klient</td>                                                                                                                                                                                                                                                                                      
                                                <td className="td_right">Saldo</td>                                                    
                                                                                                        
                                            </tr>
                                        </thead>

                                        <tbody>

                                                {
                                                    salda.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";
  

                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>                                                          
                                                                <td className="goleft"  >{row.Nazwa}</td>                                                                                                       
                                                                <td className="goright"><FormatDecimal value={row.Saldo} /></td>                                                                                                                                                                                                                                                                                                                             
                                                            </tr>

                                                    } )
                                                }

                                           

                                        </tbody>

                                </table>

          </div>

        


    </div>
}

export default Sum;


